"use strict";
exports.__esModule = true;
exports.DEFAULT_HEIGHT = void 0;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../../../theme/styled-components"));
var utilities_1 = require("../../../utilities/utilities");
exports.DEFAULT_HEIGHT = 200;
var Wrapper = styled_components_1["default"]('div')(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  display: flex;\n  width: 100%;\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  width: 100%;\n  ",
    "\n"])), function (_a) {
    var hasRatio = _a.hasRatio, width = _a.width, height = _a.height;
    return hasRatio && typeof width !== 'undefined'
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n          padding-top: ", "%;\n        "], ["\n          padding-top: ", "%;\n        "])), 100 / (width / height)) : styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n          height: ", ";\n          max-width: ", ";\n        "], ["\n          height: ", ";\n          max-width: ", ";\n        "])), polished_1.rem(height), width ? polished_1.rem(width) : '100%');
});
var Content = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
var IframeElement = styled_components_1["default"].iframe(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  margin: 0 auto;\n  height: 100%;\n  padding: 0;\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-weight: inherit;\n  font-style: inherit;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline;\n"], ["\n  margin: 0 auto;\n  height: 100%;\n  padding: 0;\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-weight: inherit;\n  font-style: inherit;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline;\n"])));
var Iframe = function (_a) {
    var _b;
    var _c = _a.data, data = _c === void 0 ? {} : _c, renderEmpty = _a.renderEmpty;
    if (!utilities_1.isBrowser()) {
        return null;
    }
    var _d = react_1["default"].useState({
        height: data.height || exports.DEFAULT_HEIGHT,
        src: ''
    }), newIframeSize = _d[0], setNewIframeSize = _d[1];
    var locationSearch = ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.search) || '';
    var src = (data.src || '')
        .replace(/{{location\.search}}/g, locationSearch)
        .replace(/{{location\.query}}/g, locationSearch ? locationSearch.substring(1) : '');
    var origin = react_1["default"].useMemo(function () {
        if (!src) {
            return '';
        }
        try {
            return new URL(src).origin;
        }
        catch (_a) {
            return '';
        }
    }, [src]);
    react_1["default"].useEffect(function () {
        if (!src) {
            return;
        }
        var handleReceiveMessage = function (e) {
            if (e.origin !== origin) {
                return;
            }
            if (e.data.newIframeSize &&
                e.data.newIframeSize.height >= 0 &&
                src === e.data.newIframeSize.src) {
                setNewIframeSize(e.data.newIframeSize);
            }
        };
        window.addEventListener('message', handleReceiveMessage, false);
        return function () {
            window.removeEventListener('message', handleReceiveMessage, false);
        };
    }, [origin, src]);
    if (!data.src && renderEmpty) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('iframe'));
    }
    if (!data.src) {
        return null;
    }
    return (react_1["default"].createElement(Wrapper, { height: data.ratio ? 100 / data.ratio : newIframeSize.height, width: data.ratio ? 100 : !!data.maxWidth ? Number(data.maxWidth) : undefined, hasRatio: !!data.ratio },
        react_1["default"].createElement(Content, null,
            react_1["default"].createElement(IframeElement, { src: src, frameBorder: "0", allowFullScreen: true, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", scrolling: data.scrolling || 'auto' }))));
};
exports["default"] = Iframe;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
